<template lang="html">
    <div
        :style="cssVars"
        class="bus-stops"
    >
        <div class="stops">
            <div
                v-for="(item, index) in spacedStops"
                :key="index"
                :class="[item ? 'circle' : 'line' ]"
            />
        </div>
        <div class="labels">
            <div
                v-for="(item, index) in stops"
                :key="index"
                class="label-container"
            >
                <div class="label">
                    {{ item }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * Expects array of stop name strings.
         * Will display nicely with up to 10 stops.
         */
        stops: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            spacedStops: [],
        };
    },
    computed: {
        /**
         * Get a JSON object of css variables based on props.
         */
        cssVars() {
            let rowHeight = 12;
            if (this.stops.length < 4) {
                rowHeight = 20;
            } else if (this.stops.length < 7) {
                rowHeight = 16;
            }
            return ({
                '--row-height': `${rowHeight}px`,
                '--first-row-height': `${rowHeight + 2}px`,
            });
        },
    },
    watch: {
        stops() {
            this.onChange();
        },
    },
    mounted() {
        this.onChange();
    },
    methods: {
        onChange() {
            // create new array of stops with null between each stop name. In the template, this allows us to know
            // where to add lines between the stop circles.
            this.spacedStops = [];
            this.stops.forEach((element, index) => {
                this.spacedStops.push(element);
                if (index !== this.stops.length - 1) {
                    this.spacedStops.push(null);
                }
            });
        },
    },
};
</script>

<style lang="scss">
.bus-stops {
    $color-stops: #33284a !default;
    $color-labels: #33284a !default;
    $color-first-stop: #f26721 !default;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-content: center;

    .stops {
        flex: 0 0 1em;
        margin-right: 0.5em;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        .circle {
            height: var(--row-height);
            width: var(--row-height);
            border: 0.2em $color-stops solid;
            border-radius: 50%;
            box-sizing: border-box;
            display: inline-block;

            &:first-child {
                height: var(--first-row-height);
                width: var(--first-row-height);
                border-color: $color-first-stop;
            }
        }

        .line {
            flex: 1;
            width: 0.3em;
            background-color: $color-stops;
            display: inline-block;
            margin: -1px 0;
        }
    }

    .labels {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .label-container {
            height: var(--row-height);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .label {
                line-height: var(--row-height);
                color: $color-labels;
                font-size: var(--row-height);
                font-weight: 400;
            }

            &:first-child {
                .label {
                    font-weight: 700;
                    font-size: var(--first-row-height);
                }
            }
        }
    }
}
</style>
